import { defineAsyncComponent } from 'vue'
export default {
  error: defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/error.vue").then(m => m.default || m)),
  site: defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/site.vue").then(m => m.default || m))
}